


export const supporting_images_data = {
  images: [
    "https://relaxium.midmetrics.io/api/representment/GetRepresentmentImageSec?guid=c306e472-c3f7-48c0-be0d-45c4940e7547",
    "https://relaxium.midmetrics.io/api/representment/GetRepresentmentImageSec?guid=cdf6b164-3033-4a53-9103-37fdc29fea7b",
    "https://relaxium.midmetrics.io/api/representment/GetRepresentmentImageSec?guid=6344e46a-d6bb-4a52-9a0c-6126438ae33a"
  ]
}